import { InputProps } from "../../Models/InputInterface";

import Text from "../../Components/Text";
import Icon from "../Icon";

import {
  Asterisk,
  ContainerInput,
  ContainerText,
  InputStyled,
  Label,
  Span,
} from "./Input.styled";

const Input = ({
  label,
  textLabel,
  placeholder,
  required,
  SubLabel,
  register,
  rules,
  errors,
  onChangeInput,
  maxLength,
  errorBeneficiary,
  typeInput,
  onInput,
  max,
  onKeyDown,
}: InputProps) => {
  return (
    <ContainerInput>
      <ContainerText>
        {required && <Asterisk>*</Asterisk>}
        {textLabel && <Label>{textLabel}</Label>}
      </ContainerText>
      {SubLabel && (
        <Text size={0} align="left" color="Dark_Silver">
          {SubLabel}
        </Text>
      )}
      <InputStyled
        type={typeInput ? typeInput : "text"}
        placeholder={placeholder}
        {...register(label, rules)}
        aria-invalid={errors && errors[label] ? "true" : "false"}
        onChange={onChangeInput ? (e) => onChangeInput(e) : null}
        maxLength={maxLength}
        $error={errors && errors[label] ? true : false}
        onInput={onInput}
        max={max}
        onKeyDown={onKeyDown}
      />
      {errors && errors[label] && (
        <ContainerText>
          <Icon
            icon={"alertTriangle"}
            color="Amaranth_Red"
            size="small"
            fillIcon={false}
          />
          <Span $error>{errors[label].message}</Span>
        </ContainerText>
      )}
      {errorBeneficiary && (
        <ContainerText>
          <Icon
            icon={"alertTriangle"}
            color="Amaranth_Red"
            size="small"
            fillIcon={false}
          />
          <Span $error>{errorBeneficiary.message}</Span>
        </ContainerText>
      )}
    </ContainerInput>
  );
};

export default Input;
